import { Component, inject } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AuthenticationService } from '../../../services/authentication.service';
import { BUTTON_SIZE, BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { EMAIL_INPUT_REGEX, emailFormat, forgotPasswordDeloitte, PASTE_EMAIL_REGEX } from '../validators.const';
import { InfoComponent } from '@shared/components/info/info.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password-modal',
  imports: [
    ButtonComponent,
    InputComponent,
    ReactiveFormsModule,
    InfoComponent,
    TranslateModule,
  ],
  templateUrl: './forgot-password-modal.component.html',
  styleUrl: './forgot-password-modal.component.scss',
})
export class ForgotPasswordModalComponent {
  protected readonly ButtonTypes = BUTTON_TYPES;
  protected readonly PASTE_EMAIL_REGEX = PASTE_EMAIL_REGEX;
  protected readonly EMAIL_INPUT_REGEX = EMAIL_INPUT_REGEX;
  protected readonly BUTTON_SIZE = BUTTON_SIZE;

  email = new FormControl('', [Validators.required, emailFormat, forgotPasswordDeloitte]);
  dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  data = inject(DIALOG_DATA);
  isSent = false;
  isSubmitted = false;

  constructor(private authService: AuthenticationService) {
  }

  resetPassword() {
    this.isSubmitted = true;
    if (this.email.valid) {
      this.authService.forgotPassword(String(this.email.value)).then(() => {
        this.isSent = true;
      });
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
